import { render } from "./customeropti.vue?vue&type=template&id=4a22de09"
import script from "./customeropti.vue?vue&type=script&lang=js"
export * from "./customeropti.vue?vue&type=script&lang=js"

import "./customeropti.vue?vue&type=style&index=0&id=4a22de09&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__